import {client} from '@core/GraphQLProvider';
import {GetTaxonomy} from './query.graphql';

if ( process.env.MOCK_API == 1 ) {
    require( './mocks' );
}

const SiteMapService = {
    async getTaxonomy() {
        const resp = await client.query( {
            query: GetTaxonomy,
            context: {timeout: 30000}
        } );

        return resp.data.taxonomy;
    }
};

export default SiteMapService;
